export default __webpack_public_path__ + "static/media/icon_greater_than_sml.72ff207f.svg";